import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Home from '@/views/Home'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'

Vue.use(Router)

let baseroute = [
    {
        path: '/',
        name: 'home',
        component: Home,
        // meta: { keepAlive: true }
    },
    {
        path: '/404',
        component: () => import('@/views/errorPage/404'),
        meta: { title: '404' }
    },
    {
        path: '/about/:type?',//关于我们
        name: 'about',
        component: () => import('@/views/About'),
        meta: { title: '关于我们', keepAlive: true }
    },
    {
        path: '/aboutCertificates',//关于证书
        name: 'aboutCertificates',
        component: () => import('@/views/aboutCertificates')
    },
    {
        path: '/examinationAccreditation',//考试认证
        name: 'examinationAccreditation',
        component: () => import('@/views/examinationAccreditation')
    },
	{
	    path: '/examinationAccredita',//专栏学习
	    name: 'examinationAccredita',
	    component: () => import('@/views/examinationAccredita')
	},
    {
        path: '/service',//服务协议
        name: 'service',
        component: () => import('@/views/service')
    },
    {
        path: '/referenceMaterial',//资料下载
        name: 'referenceMaterial',
        component: () => import('@/views/referenceMaterial')
    },
    {
        path: '/examinationNotice',//考试公告
        name: 'examinationNotice',
        component: () => import('@/views/examinationNotice')
    },
    {
        path: '/helpCenter',//帮助中心
        name: 'helpCenter',
        component: () => import('@/views/helpCenter')
    },
    {
        path: '/list/:type',
        name: 'list',
        component: () => import('@/views/list'),
        meta: { keepAlive: true } //需要缓存的列表页面添加keepAlive
    },
    {
        path: '/content/:id',
        name: 'content',
        component: () => import('@/views/content'),
        meta: { loginStatus: true } //需要判断登录状态的页面添加loginStatus
    },
	{
	    path: '/gradeDetails/:id',//考试详情
	    name: 'gradeDetails',
	    component: () => import('@/views/gradeDetails'),
	    meta: { title: '考试详情', loginStatus: true }
    },
    {
	    path: '/articleDetails',//文章详情
	    name: 'articleDetails',
	    component: () => import('@/views/articleDetails'),
	    meta: { title: '文章详情' }
	}
]

let endroute = [
    { path: '*', redirect: '/404',}
]

import loginRouter from './login'
import enrollRouter from './enroll'
import centerRouter from './center'

baseroute = baseroute.concat(loginRouter)
baseroute = baseroute.concat(enrollRouter)
baseroute = baseroute.concat(centerRouter)

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: baseroute.concat(endroute),
    // 滚动条处理
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

// 前置钩子记录来源页面name到vuex
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'CERM'
    store.commit('setRouterForm',from.name)
    if(to.name != 'login'){
        store.commit('setRouterTo',to.path)
        if(to.meta.loginStatus){
            if(getToken('token')){
                next()
            }else{
                Message({
                    message: '未登录，请前去登录',
                    type: 'error',
                    duration: 1 * 1000
                })
                setTimeout(() => {
                    next('/login')
                },1000)
            }
        }else{
            next()
        }
    }else{
        if(getToken('token') && to.path != '/login/register'){
            next('/')
        }else{
            next()
        }
    }
})

export default router